var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartConsult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16683 3.72921C3.91819 3.72921 3.67973 3.82798 3.50392 4.00379C3.3281 4.17961 3.22933 4.41807 3.22933 4.66671V16.3334C3.22933 16.582 3.3281 16.8205 3.50392 16.9963C3.67973 17.1721 3.91819 17.2709 4.16683 17.2709H15.8335C16.0821 17.2709 16.3206 17.1721 16.4964 16.9963C16.6722 16.8205 16.771 16.582 16.771 16.3334V4.66671C16.771 4.41807 16.6722 4.17961 16.4964 4.00379C16.3206 3.82798 16.0821 3.72921 15.8335 3.72921H4.16683ZM2.47272 2.9726C2.92203 2.52329 3.53141 2.27087 4.16683 2.27087H15.8335C16.4689 2.27087 17.0783 2.52329 17.5276 2.9726C17.9769 3.4219 18.2293 4.03129 18.2293 4.66671V16.3334C18.2293 16.9688 17.9769 17.5782 17.5276 18.0275C17.0783 18.4768 16.4689 18.7292 15.8335 18.7292H4.16683C3.53141 18.7292 2.92202 18.4768 2.47272 18.0275C2.02341 17.5782 1.771 16.9688 1.771 16.3334V4.66671C1.771 4.03129 2.02341 3.4219 2.47272 2.9726Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.604 8.83329C7.604 8.43059 7.93046 8.10413 8.33317 8.10413H17.4998C17.9025 8.10413 18.229 8.43059 18.229 8.83329C18.229 9.236 17.9025 9.56246 17.4998 9.56246H8.33317C7.93046 9.56246 7.604 9.236 7.604 8.83329Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33317 2.27087C8.73588 2.27087 9.06234 2.59733 9.06234 3.00004V18C9.06234 18.4027 8.73588 18.7292 8.33317 18.7292C7.93046 18.7292 7.604 18.4027 7.604 18V3.00004C7.604 2.59733 7.93046 2.27087 8.33317 2.27087Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01576 2.48444C8.30052 2.7692 8.30052 3.23088 8.01576 3.51564L3.01576 8.51564C2.731 8.8004 2.26932 8.8004 1.98456 8.51564C1.69981 8.23088 1.69981 7.7692 1.98456 7.48444L6.98456 2.48444C7.26932 2.19968 7.731 2.19968 8.01576 2.48444Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8491 5.81769C9.13385 6.10245 9.13385 6.56413 8.8491 6.84889L3.01576 12.6822C2.731 12.967 2.26932 12.967 1.98456 12.6822C1.69981 12.3975 1.69981 11.9358 1.98456 11.651L7.8179 5.81769C8.10266 5.53294 8.56434 5.53294 8.8491 5.81769Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8491 9.98444C9.13385 10.2692 9.13385 10.7309 8.8491 11.0156L3.01576 16.849C2.731 17.1337 2.26932 17.1337 1.98456 16.849C1.69981 16.5642 1.69981 16.1025 1.98456 15.8178L7.8179 9.98444C8.10266 9.69968 8.56434 9.69968 8.8491 9.98444Z",
    fill: "#4B4AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84909 14.1511C9.13385 14.4358 9.13385 14.8975 8.84909 15.1823L5.51576 18.5156C5.231 18.8004 4.76932 18.8004 4.48456 18.5156C4.19981 18.2308 4.19981 17.7692 4.48456 17.4844L7.8179 14.1511C8.10265 13.8663 8.56434 13.8663 8.84909 14.1511Z",
    fill: "#4B4AD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartConsult);
export default __webpack_public_path__ + "static/media/startConsult.960857dbeb67bc4a3eda09f0271af4c2.svg";
export { ForwardRef as ReactComponent };